import qs from "qs"

type TParams = { [key: string]: any };

export const parseQuery = <T = TParams>(search: string) => {
    search = search.replace("?", "");
    return qs.parse(search) as Partial<T>
};
export const stringifyQuery = <T = TParams>(params: T) => qs.stringify(params);